import { createExportColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { getCommonChainProxyExportColumns } from 'components/DataExpansionComponents/Common/commonExportColumns'
import { LODGING_COLUMNS } from 'components/DataExpansionComponents/GooglePlaces/Lodging/LodgingColumnsInfo'
import { HOTEL_AMENITIES } from 'constants/hotelAmenities'
import { useFeatureFlagService } from 'utils/useFeatureFlagService'
import { buildTargetExportModal } from './TargetExportModal'

const lodgingColumnHelper = createExportColumnHelper({
  columns: LODGING_COLUMNS,
})

export default buildTargetExportModal({
  targetType: 'lodging',
  isDoors: false,
  title: 'Select Columns for Lodging & Hospitality Download',
  subTitle:
    'Download up to 10,000 lodging & hospitality at a time, with any of the following columns. Any filters already applied will remain active.',
  submitText: 'Export Lodging & Hospitality',
  progressName: 'Exporting Lodging & Hospitality...',
  downloadLabel: 'Lodging Opportunities',
  useColumnGroups: () => {
    const { enableLodgingHotelAmenities } = useFeatureFlagService()
    return [
      {
        title: 'Target Attributes',
        elements: [
          lodgingColumnHelper.retrieveColumn('name'),
          lodgingColumnHelper.retrieveColumn('city_summary'),
          lodgingColumnHelper.retrieveColumn('state_summary'),
          lodgingColumnHelper.retrieveColumn('zipcode_summary'),
          lodgingColumnHelper.retrieveColumn('domain'),
          lodgingColumnHelper.retrieveColumn('reviews_avg'),
          lodgingColumnHelper.retrieveColumn('reviews_cnt'),
          lodgingColumnHelper.retrieveColumn('open_hours'),
          lodgingColumnHelper.retrieveColumn('doors_cnt'),
        ],
      },
      ...(enableLodgingHotelAmenities
        ? [
            {
              title: 'Hotel Amenities',
              elements: HOTEL_AMENITIES.map((a) => [a.key, `Has ${a.label}`]),
            },
          ]
        : []),
      {
        title: 'Predicted Values and Deals',
        elements: getCommonChainProxyExportColumns(),
      },
    ]
  },
})
